<template>
	<div class="col-sm-12" :class="grid ? 'col-md-' + grid : 'col-md-12'">
		<div :class="`mb-2 ${inputGroup ? 'form-group' : ''}`">
			<label class="d-block font-weight-bold">
				{{ label }}
				<span v-if="required" class="text-danger">*</span>
			</label>
			<div class="d-flex bd-highlight">
				<input
					v-model="item"
					:type="type ? type : 'text'"
					class="form-control flex-fill bd-highlight"
					:class="label == undefined ? (mt == undefined ? 'mt-4' : `mt-${mt}`) : ''"
					:readonly="readonly"
					:disabled="disabled"
					:placeholder="placeholder ? placeholder : label"
					:required="required"
				/>
				<v-input-colorpicker
					:style="`background: ${item} !important`"
					class="flex-fill bd-highlight"
					v-model="item"
					v-on:input="$emit('input', item), $emit('change')"
				/>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: [
		"type",
		"value",
		"label",
		"required",
		"grid",
		"readonly",
		"disabled",
		"placeholder",
		"mt",
		"inputGroup",
		"iconBtn",
		"btnText",
	],
	data() {
		return { item: null };
	},
	beforeMount() {
		this.item = this.value;
	},
	watch: {
		value(n, o) {
			this.item = n;
		},
	},
};
</script>
<style lang="css" scoped>
.icp__input {
	border-radius: 0 !important;
	margin-bottom: 0;
	height: calc(1.5em + 0.75rem + 2px) !important;
}
</style>
